import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Glass = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M18.75 1.615a.373.373 0 0 0-.381-.365h-2.865l-.434 1.458h1.017a.38.38 0 0 1 .352.226.35.35 0 0 1-.082.397l-3.805 3.646c-.074.07-.163.15-.353.122a.353.353 0 0 1-.286-.468l.642-2.464h-1.034a.39.39 0 0 1-.333-.188.35.35 0 0 1 .01-.37l1.54-2.359H1.63c-.21 0-.38.163-.38.365 0 4.254 3.247 7.77 7.608 8.31v6.637H6.956c-1.048 0-1.902.818-1.902 1.823 0 .202.17.365.38.365h9.13c.21 0 .381-.163.381-.365 0-1.005-.854-1.823-1.902-1.823h-1.902V9.925c4.361-.54 7.608-4.056 7.608-8.31Z" }) }));
});
Glass.displayName = 'Glass';
export default Glass;
//# sourceMappingURL=Glass.js.map